import React from 'react';
import styled from 'styled-components';
import PageTitle from 'spark-ui/ui-kitchen/ingredients/spices/PageTitle';
import Subtitle from 'spark-ui/ui-kitchen/ingredients/spices/Subtitle';

/**
 Page Layout
 ----------------------------------
 | Optional Navigation            |
 |--------------------------------|
 | Title                          |
 |--------------------------------|
 | Optional Subtitle              |
 |--------------------------------|
 |                                |
 |                                |
 |            Content             |
 |                                |
 |                                |
 |________________________________|
 */

const PageContainer = styled.div`
    & .page-navigation {
        margin-bottom: 0.2em;
        top: 0em;
        position: relative;
    }
`;

const ContentArea = styled.div`
    background-color: #fff;
    padding: 2.5em;

    & ${PageTitle} {
        margin-bottom: 0.5em;
    }
    & ${Subtitle} {
        margin-bottom: 1em;
    }
`;

const Page = ({ title, subtitle, navigation, children }) => {
    return (
        <PageContainer>
            {navigation && <div className="page-navigation">{navigation}</div>}
            <ContentArea>
                {title && <PageTitle>{title}</PageTitle>}
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
                <div className="page-content">{children}</div>
            </ContentArea>
        </PageContainer>
    );
};

export default Page;
